<div class="kfm-contact-book-dialog" [hsLayer]="'one'" style="display: flex; flex-direction: column; height: 100%; max-height: 90vh;">
  <div style="flex-shrink: 0;">
    <hs-search-bar
      (searchChanged)="onSearchValueChanged($event)"
      [hsLayer]="'two'"
    ></hs-search-bar>
  </div>
  <div style="flex: 1; min-height: 0; overflow: auto;">
    <hs-contact-book
      (contactSelected)="onContactSelected($event.contact)"
      [dataSource]="contactDataSource.dataSource"
      [hsLayer]="'two'"
    ></hs-contact-book>
  </div>

  <div class="flex flex-row w-full justify-end gap-2 p-2" style="flex-shrink: 0;">
    <button
      hsButton
      hsButtonSize="sm"
      hsButtonVariant="outlined"
      (click)="dialogRef.close()"
    >
      {{ cancelLabel }}
    </button>
    <button
      hsButton
      hsButtonSize="sm"
      hsButtonVariant="filled"
      (click)="dialogRef.close(selectedContact)"
    >
      {{ okLabel }}
    </button>
  </div>
</div>
